import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { Ladder } from '../../../models/ladder.model';

@Component({
  selector: 'admin-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['impersonate.component.scss']
})
export class AdminImpersonateComponent implements OnInit {
  /** Only disables the nickname controls for the row being saved */
  public savingNicknameUserId: string | null = null;
  /** Per-row result after Set (same line as the button) */
  public nicknameInline: { [userId: string]: { ok: boolean; text: string } } = {};
  public players: Player[] = [];
  public ladders: Ladder[] = [];
  public ladderId: string;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private routerLink: Router) {
  }

  ngOnInit(): void {
    this.loadPlayers();
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders = resp.map(l => new Ladder(l));
        this.ladders.unshift(new Ladder({ ladderId: null, name: 'Clear/Blank/Null' }))
      }
    );
  }

  /** Loads the full player list once; not called again after nickname updates. */
  private loadPlayers(): void {
    const url = `/admin/getallplayers`;
    this.http.get<Player[]>(url).subscribe(
      (resp: Player[]) => {
        console.log(resp);
        this.players.length = 0;
        for (let p of resp) {
          this.players.push(new Player(p));
        }
      }
    );
  }

  public impersonate(evt: any, id: string): void {
    var oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    document.cookie = `impersonate=${id}; expires=${oneYearFromNow.toDateString()}; path=/`;

    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    this.routerLink.navigate(['/home']);
  }

  public clear(evt: any) {
    document.cookie = `impersonate=; path=/`;
    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    this.routerLink.navigate(['/home']);
  }

  public setNickname(p: Player): void {
    this.savingNicknameUserId = p.id;
    delete this.nicknameInline[p.id];
    const body = { userId: p.id, nickname: (p.nickname ?? '').trim() };
    this.http.post<{ userId: string; nickname?: string }>('/admin/setnickname', body).subscribe({
      next: (_resp) => {
        // Keep the value already in the input; no refetch and no overwrite from server
        this.nicknameInline[p.id] = { ok: true, text: 'Saved' };
        this.savingNicknameUserId = null;
      },
      error: (err) => {
        const e = err.error;
        let msg: string;
        if (typeof e === 'string') {
          msg = e;
        } else {
          msg = (e && (e.error || e.message)) ? (e.error || e.message) : 'Failed to set nickname';
        }
        this.nicknameInline[p.id] = { ok: false, text: msg };
        this.savingNicknameUserId = null;
      }
    });
  }

}
